const data = {
    title: '3. Kaders vanuit wetgeving, beleid en richtlijnen',
    content: <>
          <p>Wet- en regelgeving en beleid stellen randvoorwaarden aan de ontwikkeling van zonnevelden en turbines in de zoekgebieden. In dit hoofdstuk staan daarom de algemeen geldende kaders vanuit wetgeving, beleid en richtlijnen omschreven. Hiervoor wordt gekeken naar de verschillende schaalniveaus waar vanuit deze kaders gelden, namelijk nationaal, provinciaal en regionaal niveau. Op het regionale niveau zijn ook de ambities vanuit de RES’en beschreven.</p>      
    </>,
    prev: '/energietransitie/2/3',
    next: '/energietransitie/3/1',

}

export default data